export default __webpack_public_path__ + "static/media/thumbnail.d701df47.png";